import Offcanvas from "react-bootstrap/Offcanvas";
import Dropdown from "react-bootstrap/Dropdown";
import React, { useState } from "react";
import { BoxArrowLeft, ChevronDown, Globe } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import useGetUrlLocale from "../../hooks/useGetUrlLocale";
import MenuList from "./menuList";
import { useBookingQuery } from "../../graphql/booking.hooks";

const languages = [
  { value: "en", label: "English" },
  { value: "es", label: "Español" },
  { value: "uk", label: "Українська" },
];

const ME_BOOKING_LINK = process.env.REACT_APP_ME_BOOKING_URL;

export default function Menu() {
  const navigate = useNavigate();
  const location = useLocation();
  const lng = useGetUrlLocale();
  const [show, setShow] = useState(false);

  const { t, i18n } = useTranslation();
  const lang = i18n.language.split("-")[0];
  const { error } = useBookingQuery();
  if (error?.message === "User not found") {
    window.location.href =
      lng === "en"
        ? `${process.env.REACT_APP_ME_BOOKING_URL}?modal=login&targetBack=${window.location.origin}${location.pathname}${location.search}`
        : `${process.env.REACT_APP_ME_BOOKING_URL}/${lng}?modal=login&targetBack=${window.location.origin}${location.pathname}${location.search}`;
  }
  const changeLanguage = (lng: string) => {
    const queryParams = new URLSearchParams(location.search).toString();

    const currentPath = location.pathname
      .split("/")
      .slice(i18n.language.split("-")[0] === "en" ? 1 : 2)
      .join("/");

    const newPath = lng === "en" ? `/${currentPath}` : `/${lng}/${currentPath}`;
    const finalPath = queryParams ? `${newPath}?${queryParams}` : newPath;

    navigate(finalPath, { replace: true });
    i18n.changeLanguage(lng);
  };
  const handleExit = () => {
    window.location.href = `${ME_BOOKING_LINK}/logout`;
  };
  return (
    <>
      <div className="col-12 col-lg-3 col-xxl-2 bg-white border-end">
        <div className="col-12 col-lg-3 col-xxl-2 d-none d-lg-flex admin-left-menu p-4 h-100 flex-column justify-content-between fixed-top">
          <div>
            <div className="text-center">
              <a
                href={ME_BOOKING_LINK + lng + "#"}
                className="pb-4 d-inline-block"
              >
                <img
                  src={`${ME_BOOKING_LINK}/build/images/logo-main.svg`}
                  alt="Me-Booking"
                  width="125"
                  height="40"
                />
              </a>
            </div>
            <MenuList />
          </div>
          <ul className="pt-3 pb-4 d-flex justify-content-between align-items-center list-unstyled px-4">
            <li>
              <a
                className="text-dark text-decoration-none"
                href="#"
                onClick={handleExit}
              >
                <BoxArrowLeft className="me-3" />
                <small>{t("menu.logout")}</small>
              </a>
            </li>
            <li>
              <Dropdown>
                <Dropdown.Toggle
                  id="dropdown-basic"
                  variant="link"
                  className="no-toggle text-uppercase text-dark text-decoration-none"
                >
                  <Globe className="me-3" />
                  <small>{lang}</small>
                  <ChevronDown className="ms-2" />
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  {languages.map((item) => (
                    <Dropdown.Item
                      key={item.value}
                      onClick={() => changeLanguage(item.value)}
                    >
                      {item.label}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </li>
          </ul>
        </div>
        <nav className="navbar bg-white fixed-top d-lg-none">
          <div className="container-fluid">
            <button
              onClick={() => setShow(true)}
              className="navbar-toggler border-0"
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasNavbar"
              aria-controls="offcanvasNavbar"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <a
              className="navbar-brand m-auto"
              href={ME_BOOKING_LINK + lng + "#"}
            >
              <img
                src={`${ME_BOOKING_LINK}/build/images/logo-main.svg`}
                alt="Me-Booking"
                width="125"
                height="40"
              />
            </a>

            <Offcanvas
              show={show}
              onHide={() => setShow(false)}
              placement="end"
            >
              <div className="offcanvas-header">
                <h5 className="offcanvas-title" id="offcanvasNavbarLabel">
                  <img
                    src={`${ME_BOOKING_LINK}/build/images/logo-main.svg`}
                    alt="Me-Booking"
                    width="126"
                    height="40"
                  />
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShow(false)}
                ></button>
              </div>
              <div className="offcanvas-body">
                <MenuList setShow={setShow} />
                <ul className="pt-3 pb-4 d-flex justify-content-between align-items-center list-unstyled px-4">
                  <li>
                    <a
                      className="text-dark text-decoration-none"
                      href="#"
                      onClick={handleExit}
                    >
                      <BoxArrowLeft className="me-3" />
                      <small>{t("menu.logout")}</small>
                    </a>
                  </li>
                  <li>
                    <Dropdown>
                      <Dropdown.Toggle
                        id="dropdown-basic"
                        variant="link"
                        className="no-toggle text-uppercase text-dark text-decoration-none"
                      >
                        <Globe className="me-3" />
                        <small>{lang}</small>
                        <ChevronDown className="ms-2" />
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        {languages.map((item) => (
                          <Dropdown.Item
                            key={item.value}
                            onClick={() => {
                              changeLanguage(item.value);
                              setShow(false);
                            }}
                          >
                            {item.label}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </li>
                </ul>
              </div>
            </Offcanvas>
          </div>
        </nav>
      </div>
    </>
  );
}
